module.exports = __webpack_public_path__ + "img/migros-bank.9959e5b8.svg";